import { Component } from "../base/Component";
import { ContextMenu } from "../components/contextmenu/ContextMenu";
import { ContextMenuLabel } from "../components/contextmenu/ContextMenuLabel";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";

export interface ContextMenuCreationListener extends EventListener<ContextMenuCreationEvent> {
}

export class ContextMenuCreationEvent extends Event<Component> {
    private _contextMenu: ContextMenu = null;

    constructor(component: Component, contextMenu: ContextMenu, domEvent?: DomEvent) {
        super(component, domEvent);
        this._contextMenu = contextMenu;
    }

    get contextMenu(): ContextMenu {
        return this._contextMenu;
    }

    get menuLabels(): ContextMenuLabel[] {
        return this._contextMenu?.menuLabels ?? [];
    }
}
